/* import __COLOCATED_TEMPLATE__ from './empty-state-illustration.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import templateOnlyComponent from '@ember/component/template-only';

export interface Args {}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

const EmptyStateIllustration = templateOnlyComponent<Signature>();
export default EmptyStateIllustration;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::EmptyStateIllustration': typeof EmptyStateIllustration;
  }
}
